'use client';

import { ThreadPrimitive } from '@assistant-ui/react';
import { Button } from '@/components/ui/button';
import { LightbulbIcon, Target } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface Suggestion {
  prompt: string;
  isGoalBased?: boolean;
  goalType?: 'frequency' | 'topic' | 'speaker';
}

interface SuggestedPromptsBarProps {
  suggestions: Suggestion[];
  className?: string;
}

export function SuggestedPromptsBar({ suggestions, className }: SuggestedPromptsBarProps) {
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  const displaySuggestions = suggestions.slice(0, 4);

  return (
    <div className={cn("px-4 py-3", className)}>
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-wrap gap-2 justify-start">
          {displaySuggestions.map((suggestion, index) => (
            <ThreadPrimitive.Suggestion
              key={index}
              prompt={suggestion.prompt}
              send
            >
              <Button
                variant="outline"
                size="sm"
                className={cn(
                  "text-xs h-8 px-3 transition-all duration-200",
                  suggestion.isGoalBased
                    ? "border-purple-300 dark:border-purple-700 bg-purple-50 dark:bg-purple-950/30 hover:bg-purple-100 dark:hover:bg-purple-900/50 hover:border-purple-400 text-purple-700 dark:text-purple-300"
                    : "hover:bg-muted hover:border-border"
                )}
              >
                {suggestion.isGoalBased ? (
                  <Target className="w-3 h-3 mr-1.5 text-purple-500" />
                ) : (
                  <LightbulbIcon className="w-3 h-3 mr-1.5" />
                )}
                <span className="truncate max-w-[200px]">{suggestion.prompt}</span>
              </Button>
            </ThreadPrimitive.Suggestion>
          ))}
        </div>
      </div>
    </div>
  );
}
